// extracted by mini-css-extract-plugin
module.exports = {"Currencies":"Currencies__Currencies__1BXLQ","instruction":"Currencies__instruction__1CU0-"};